var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-screen-lg mx-auto"},[_c('picture-input',{ref:"pictureInput",attrs:{"width":"2500","height":"1500","accept":"image/jpeg, image/png","size":"10","zIndex":1,"hideChangeButton":true,"custom-strings":{
      upload: 'ภาพหน้าปก',
      drag: 'เลือกภาพหน้าปก',
    }},on:{"change":_vm.onFeaturedImageChange}}),_c('a-form-item',{staticClass:"mt-12",attrs:{"label":"หัวข้อ"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:(['note', { rules: [{ required: true, message: 'เนื้อหา' }] }]),expression:"['note', { rules: [{ required: true, message: 'เนื้อหา' }] }]"}],model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1),_c('a-form-item',{attrs:{"label":"เนื้อหา"}},[_c('editor',{attrs:{"content":_vm.content},on:{"change":function (html) { return (_vm.content = html); }}})],1),_c('a-form-item',{attrs:{"label":"ลิงค์อ้างอิง"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:(['refUrl', { rules: [{ required: true, message: 'ลิงค์อ้างอิง' }] }]),expression:"['refUrl', { rules: [{ required: true, message: 'ลิงค์อ้างอิง' }] }]"}],model:{value:(_vm.refUrl),callback:function ($$v) {_vm.refUrl=$$v},expression:"refUrl"}})],1),_c('a-form-item',{attrs:{"label":"เลือกกลุ่มผู้รับ (เลือกได้มากกว่า 1 กลุ่ม)"}},[_c('a-checkbox-group',{staticClass:"flex flex-col",attrs:{"options":[
        {
          label: "ผู้มีความเสี่ยงสุขภาพสูง",
          value: 'HEALTH_HIGH_RISK',
        },
        {
          label: "ผู้มีความเสี่ยงสุขภาพปานกลาง ",
          value: 'HEALTH_MEDIUM_RISK',
        },
        {
          label: "ผู้มีความเสี่ยงสุขภาพต่ำ ",
          value: 'HEALTH_LOW_RISK',
        },
        {
          label: "ผู้มีคุณภาพชีวิตที่ไม่ดี ",
          value: 'WHOQOL_LOW',
        },
        {
          label: "การมีคุณภาพชีวิตกลางๆ",
          value: 'WHOQOL_MEDIUM',
        },
        {
          label: "การมีคุณภาพชีวิตที่ดี",
          value: 'WHOQOL_HIGH',
        },
        {
          label: "ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์ดีมาก",
          value: 'HPLP_VERY_GOOD',
        },
        {
          label: "ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์ดี",
          value: 'HPLP_GOOD',
        },
        {
          label: "ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์พอใช้",
          value: 'HPLP_FAIR',
        },
        {
          label: "ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์ปรับปรุง",
          value: 'HPLP_BAD',
        } ]},model:{value:(_vm.targets),callback:function ($$v) {_vm.targets=$$v},expression:"targets"}})],1),_c('a-button',{staticClass:"text-white mt-16",attrs:{"type":"primary","block":""},on:{"click":_vm.submit}},[_vm._v("บันทึก")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }